<select #input class="form-control" [ngModel]="value" (ngModelChange)="onCountryChange($event, true)" [disabled]="loading">
  <option value="">- Choose Country -</option>
  <option [value]="country.code" *ngFor="let country of countryList">{{ country.name }}</option>
</select>

<div class="overlay" *ngIf="loading">
  <span>Please wait...</span>
</div>
